import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Püsikliendi hind

  <span style="color:#85c1dc;">**FI:**</span>
  Kanta-asiakashinta

  <span style="color:#85c1dc;">**RU:**</span>
  Цена для киента ON24
*/
/* @__NO_SIDE_EFFECTS__ */
const m17 = msg(
  mf`Püsikliendi hind`,
  mf`Kanta-asiakashinta`,
  mf`Цена для киента ON24`,
)

export { m17 as 'w.module.product.best_price_label' }